export interface LineHaulRateDto {
  lineHaulRate: number;
  isFlatRate: boolean;
}
